export var Views = /*#__PURE__*/function (Views) {
  Views["SERVICEPROVIDER"] = "root-view-service-provider";
  Views["CLIENTPORTAL"] = "root-view-client";
  Views["LEGACYCLIENTDASHBOARD"] = "root-view-client-dashboard";
  return Views;
}({});